import { send } from "../../send";

/**
 * send(1.method, 2.url, 3.data, 4.expend) 1.请求类型 2.请求地址 3.请求参数 4.拓展(如统一的uuid)
 * 告警模块
 */

export const Warn = {
    /**
     * 告警规则
     * @param {*} parmas 
     * @param {*} expend 
     */
    // 获取告警规则列表
    getWarnRoleList(parmas, expend) {
        return send("GET", "/api/company/siteWarnRule/find", parmas, expend);
    },
    // 删除一条告警规则
    getWarnRoleDel(parmas, expend) {
        return send("GET", "/api/company/siteWarnRule/del", parmas, expend);
    },
    // 添加一条告警规则
    postWarnRoleAdd(parmas, expend) {
        return send("POST", "/api/company/siteWarnRule/create", parmas, expend);
    },
    // 更新一条告警规则
    postWarnRoleEdit(parmas, expend) {
        return send("POST", "/api/company/siteWarnRule/modify", parmas, expend);
    },
    // 通过设备查询告警规则
    getWarnRule(parmas, expend) {
        return send("GET", "/api/company/siteWarnRule/device/ruleList", parmas, expend);
    },
    // 绑定告警规则
    postWarnBinding(parmas, expend) {
        return send("POST", "/api/company/siteWarnRule/device/binding", parmas, expend);
    },
    // 解绑告警规则
    postWarnNotBind(parmas, expend) {
        return send("POST", "/api/company/siteWarnRule/device/unbind", parmas, expend);
    },
    /**
     * 告警事件列表
     */
    getWarnDataList(parmas, expend) {
        return send("GET", "/api/company/waterWarnLog/find", parmas, expend);
    },
    /**
     * 告警电流值列表
     */
    getWarnAiList(parmas, expend) {
        return send("GET", "/api/company/extConsumerWarn/find", parmas, expend);
    },
    getWarnChartAi(parmas, expend) {
        return send("GET", "/api/company/extConsumerWarn/statistics", parmas, expend);
    },
    /**
     * 环保日报
     */
    getTodayData(parmas, expend) {
        return send("GET", "/api/park/report/query", parmas, expend);
    },
    /**
     * 到处exl
     */
    portExp(parmas, expend) {
        return send("GET", "/api/park/report/exp", parmas, expend);
    },
    /**
    * 民众关注统计
    */
    getVisitor(parmas, expend) {
        return send("GET", "/api/park/report/visitor", parmas, expend);
    },
    /**
    * 近期告警列表
    */
    getCurrentWarnSummaryList(parmas, expend) {
        return send("GET", "/api/park/waterWarnLog/summary", parmas, expend);
    },
}